<template>
  <div class="spinner">
    <v-progress-circular indeterminate color="#145074"></v-progress-circular>
  </div>
</template>

<script>
export default {
  name: 'Spinner',
}
</script>

<style lang="less" scoped>
.spinner {
  display: flex;
  justify-content: center;
  margin-top: calc(100vh / 2.3);
}
</style>
